export const products = {
  antibiotic: [
    { name: "Avilamycin Premix", nameZh: "阿维拉霉素预混剂", specs: "10%, 20% | CVP | 25kg/bag" },
    { name: "Nosiheptide Premix", nameZh: "那西肽预混剂", specs: "0.5%, 1%, 2%, 4% | CVP | 25kg/bag" },
    { name: "Enramycin Premix", nameZh: "恩拉霉素预混剂", specs: "4%, 8%, 10% | CVP | 25kg/bag" },
    { name: "Kitasamycin Premix", nameZh: "北里霉素预混剂", specs: "10%, 50% | CVP | 25kg/bag" },
    { name: "Lincomycin Premix", nameZh: "林可霉素预混剂", specs: "4.4%, 11% | CVP | 25kg/bag" },
    { name: "Quinocetone Premix", nameZh: "喹烯酮预混剂", specs: "10%, 50% | CVP | 25kg/bag" },
    { name: "Colistin Sulfate Premix", nameZh: "硫酸粘菌素预混剂", specs: "10%, 20% | CVP | 25kg/bag" },
    { name: "Tylosin Phosphate Premix", nameZh: "磷酸泰乐菌素预混剂", specs: "10% | CVP | 25kg/bag" },
    { name: "Florfenicol Premix", nameZh: "氟苯尼考预混剂", specs: "10%, 20% | CVP | 25kg/bag" },
    { name: "Enrofloxacin Premix", nameZh: "恩诺沙星预混剂", specs: "10%, 20% | CVP | 25kg/bag" },
    { name: "Tiamulin Fumarate Premix", nameZh: "延胡索酸泰妙菌素预混剂", specs: "10%, 80% | CVP | 25kg/bag" },
    { name: "Tylvalosin Tartrate Premix", nameZh: "酒石酸泰万菌素预混剂", specs: "50% | CVP | 25kg/bag" },
    { name: "Tiamulin Premix", nameZh: "泰妙菌素预混剂", specs: "10%" },
    { name: "Tilmicosin Premix", nameZh: "替米考星预混剂", specs: "20%" },
    { name: "Tylosin Premix", nameZh: "泰乐菌素预混剂", specs: "10%" },
    { name: "Amoxicillin Premix", nameZh: "阿莫西林预混剂", specs: "10%" }
  ],
  coccidiostat: [
    { name: "Maduramycin Ammonium Premix", nameZh: "马杜霉素铵预混剂", specs: "1%, 2%, 5%, 10% | CVP | 25kg/bag" },
    { name: "Monensin Sodium Premix", nameZh: "莫能菌素钠预混剂", specs: "20%, 40% | CVP | 25kg/bag", brochure: {
      file: "monensin-premix-literature.pdf",
      downloadName: "PritBiotech Monensin Premix.pdf",
      buttonLabel: "Download Brochure",
      buttonLabelZh: "下载产品手册"
    } },
    { name: "Nicarbazine Premix", nameZh: "尼卡巴嗪预混剂", specs: "25% | CVP | 25kg/bag", brochure: {
      file: "nicarbazine-premix-literature.pdf",
      downloadName: "PritBiotech Nicarbazine Premix.pdf",
      buttonLabel: "Download Brochure",
      buttonLabelZh: "下载产品手册"
    } },
    { name: "Decoquinate Premix", nameZh: "癸氧喹酯预混剂", specs: "6% | CVP | 25kg/bag" },
    { name: "Robenidine Hydrochloride Premix", nameZh: "盐酸氯苯胍预混剂", specs: "6.6%, 10% | CVP | 25kg/bag" },
    { name: "Clopidol Premix", nameZh: "氯羟吡啶预混剂", specs: "25% | CVP | 25kg/bag" },
    { name: "Diclazuril Premix", nameZh: "地克珠利预混剂", specs: "0.5%, 1% | CVP | 25kg/bag", brochure: {
      file: "diclazuril-premix-literature.pdf",
      downloadName: "PritBiotech Diclazuril Premix.pdf",
      buttonLabel: "Download Brochure",
      buttonLabelZh: "下载产品手册"
    } },
    { name: "Dinitolmide Premix", nameZh: "二硝托胺预混剂", specs: "25% | CVP | 25kg/bag" },
    { name: "Salinomycin Premix", nameZh: "盐霉素预混剂", specs: "12% | 25kg/bag", brochure: {
      file: "salinomycin-premix-literature.pdf",
      downloadName: "PritBiotech Salinomycin Premix.pdf",
      buttonLabel: "Download Brochure",
      buttonLabelZh: "下载产品手册"
    } },
    { name: "Maduramycin Ammonium & Nicarbazine Premix", nameZh: "马杜霉素铵和尼卡巴嗪预混剂", specs: "0.75%+8%, 1.5%+16% | CVP | 25kg/bag" },
    { name: "Monensin Sodium & Nicarbazine Premix", nameZh: "莫能菌素钠和尼卡巴嗪预混剂", specs: "8%+8%, 16%+16% | CVP | 25kg/bag" },
    { name: "Salinomycin + Nicarbazine Premix", nameZh: "盐霉素+尼卡巴嗪预混剂", specs: "8%+8%, 12%+6% | 25kg/bag" },
    { name: "Nicarbazin and Ethopabate Premix", nameZh: "尼卡巴嗪和乙氧酰胺苯甲酯预混剂", specs: "25%+1.6% | CVP | 25kg/bag" }
  ],
  api: [
    { name: "Nicarbazine", nameZh: "尼卡巴嗪", specs: "CVP" },
    { name: "Nosiheptide", nameZh: "那西肽", specs: "CVP" },
    { name: "Avilamycin", nameZh: "阿维拉霉素", specs: "IN-HOUSE" },
    { name: "Kitasamycin", nameZh: "北里霉素", specs: "IN-HOUSE" },
    { name: "Maduramycin Ammonium", nameZh: "马杜霉素铵", specs: "CVP" },
    { name: "Monensin Sodium", nameZh: "莫能菌素钠", specs: "CVP" },
    { name: "Decoquinate", nameZh: "癸氧喹酯", specs: "CVP" },
    { name: "Quinocetone", nameZh: "喹烯酮", specs: "CVP" },
    { name: "Sulfadiazine", nameZh: "磺胺嘧啶", specs: "" },
    { name: "Sulfachloropyrazine Sodium", nameZh: "磺胺氯吡嗪钠", specs: "" },
    { name: "Sulfamonomethoxine Sodium", nameZh: "磺胺间甲氧嘧啶钠", specs: "" }
  ],
  binder: [
    { name: "Prit Binder", nameZh: "普瑞特粘合剂", specs: "Modified Cassava Starch Adhesive" }
  ],
  otherPremix: [
    {
      name: "Beta Mineral Pro",
      nameZh: "Beta Mineral Pro 矿物复合预混剂",
      specs: "Trace mineral premix (Cu, Fe, Zn, Mn, I, Se) | 25kg/bag",
      details: {
        summary:
          "Produced by natural copper and zinc mineral materials with ionized purification technology. Supports mineral supplementation, immunity, and growth in animals.",
        summaryZh:
          "采用天然铜、锌矿物原料并经离子提取净化工艺制成，可用于补充矿物元素、增强免疫并促进动物生长。",
        composition: [
          "Copper (Copper hydroxychloride): 522000 mg/kg",
          "Zinc (Zinc hydroxychloride): 27500 mg/kg"
        ],
        compositionZh: [
          "铜（羟氯化铜）：522000 mg/kg",
          "锌（羟氯化锌）：27500 mg/kg"
        ],
        dosage:
          "To make 1 MT of compound feed, use 240-480 g of CZ Grow Fine (equivalent to 125-250 ppm Copper and 6.6-13.2 ppm Zinc).",
        dosageZh:
          "每生产 1 吨配合饲料，添加 240-480 g CZ Grow Fine（相当于铜 125-250 ppm、锌 6.6-13.2 ppm）。",
        uses: [
          "Supply adequate copper and zinc to poultry",
          "Improve poultry performance",
          "Support proper muscle development of birds",
          "Promote stronger immunity",
          "Enhance growth of birds"
        ],
        usesZh: [
          "为家禽补充充足铜和锌",
          "提升家禽生产性能",
          "促进禽类肌肉正常发育",
          "增强机体免疫力",
          "促进禽类生长"
        ],
        shelfLife: "24 months from production date",
        shelfLifeZh: "自生产日期起 24 个月",
        countryOfOrigin: "Made in China",
        countryOfOriginZh: "中国制造",
        precaution:
          "Store in a cool and dry place. Protect from direct sunlight and moisture. Use as early as possible after opening.",
        precautionZh:
          "置于阴凉干燥处保存，避免阳光直射和受潮。开袋后请尽快使用。",
        packaging: "25kg",
        packagingZh: "25kg",
        exporter: {
          name: "TONGDA ENTERPRISES COMPANY LIMITED",
          address: "6/F MANULIFE PLACE 348 KWUN TONG ROAD, KL, HONGKONG.",
          email: "bruce.guo@shmoxisw.com",
          phone: "+86 15821422068",
          website: "https://pritbiotech.com/",
          websiteNote: "(Manufacturing Company)"
        },
        exporterZh: {
          title: "出口方",
          name: "通达企业有限公司",
          address: "香港九龙观塘道348号宏利广场6楼",
          email: "bruce.guo@shmoxisw.com",
          phone: "+86 15821422068",
          website: "https://pritbiotech.com/",
          websiteNote: "（生产公司）"
        }
      }
    },
    {
      name: "Pepti Mineral Boost Premix (Feed Grade)",
      nameZh: "肽矿物强化预混剂（饲料级）",
      specs: "Chelated mineral premix for dairy cattle (Cu, Fe, Mn, Zn, I, Se) | 25kg/bag",
      details: {
        summary:
          "Chelated mineral premix for dairy cattle. Rich in trace elements with small peptide chelated organic minerals for high bioavailability and dual nutritional function.",
        summaryZh:
          "适用于奶牛的小肽螯合矿物预混剂，富含微量元素，具有双重营养功能和高生物利用率。",
        compositionTable: [
          { no: 1, ingredient: "Cu, mg/kg", value: "6400-9600" },
          { no: 2, ingredient: "Fe, mg/kg", value: "16000-24000" },
          { no: 3, ingredient: "Mn, mg/kg", value: "40000-60000" },
          { no: 4, ingredient: "Zn, mg/kg", value: "52000-78000" },
          { no: 5, ingredient: "I, mg/kg", value: "1000-1800" },
          { no: 6, ingredient: "Se, mg/kg", value: "300-500" }
        ],
        compositionTableZh: [
          { no: 1, ingredient: "铜, mg/kg", value: "6400-9600" },
          { no: 2, ingredient: "铁, mg/kg", value: "16000-24000" },
          { no: 3, ingredient: "锰, mg/kg", value: "40000-60000" },
          { no: 4, ingredient: "锌, mg/kg", value: "52000-78000" },
          { no: 5, ingredient: "碘, mg/kg", value: "1000-1800" },
          { no: 6, ingredient: "硒, mg/kg", value: "300-500" }
        ],
        features: [
          "Dual Nutritional Function Rich in Trace Elements: Small peptide chelated organic minerals enter animal cells as a whole; the chelation bond breaks to release peptides and metal ions, both utilized by the animal for dual nutritional benefits.",
          "High Bioavailability: Utilizes both small peptide chelated organic mineral and metal ion absorption channels, with absorption rates 2 to 6 times higher than inorganic trace elements.",
          "Reduce Nutrient Loss in Feed: Chelated minerals protect elements so most are released in the small intestine, preventing insoluble salt formation and alleviating antagonistic competition between minerals."
        ],
        featuresZh: [
          "双重营养功能、富含微量元素：小肽螯合有机矿物整体进入动物细胞，螯合键断裂后释放肽和金属离子，动物同时利用两者，发挥双重营养作用。",
          "高生物利用率：利用小肽螯合有机矿物和金属离子双重吸收通道，吸收率比无机微量元素高2至6倍。",
          "减少饲料营养流失：小肽螯合有机矿物保护元素，使大部分在小肠释放，有效防止与其他离子形成不溶性无机盐，缓解矿物间的拮抗竞争。"
        ],
        benefits: [
          "Increases milk yield and improves milk quality, promoting the growth performance of dairy cows.",
          "Enhances immunity, alleviates stress, and boosts disease resistance.",
          "Supplies the necessary minerals, preventing nutritional deficiencies in dairy cows.",
          "Through precise nutritional supplementation, accelerates tissue and functional recovery in dairy cows, helping to restore body condition rapidly."
        ],
        benefitsZh: [
          "提高产奶量、改善奶品质，促进奶牛生长性能。",
          "增强免疫力、缓解应激、提高抗病能力。",
          "补充必需矿物质，预防奶牛营养缺乏。",
          "通过精准营养补充，加速奶牛组织和功能恢复，帮助快速恢复体况。"
        ],
        dosage: "1–2 kg per MT of compound feed",
        dosageZh: "每吨配合饲料添加 1–2 kg",
        shelfLife: "12 months",
        shelfLifeZh: "12 个月",
        precaution: "Store in a cool, ventilated, dry, and dark place.",
        precautionZh: "置于阴凉、通风、干燥、避光处保存。",
        packaging: "25kg/bag",
        packagingZh: "25kg/袋",
        exporter: {
          title: "Contact",
          email: "bruce.guo@shmoxisw.com",
          phone: "+86 15821422068",
          website: "https://pritbiotech.com/",
          websiteNote: "(Manufacturing Company)"
        },
        exporterZh: {
          title: "联系方式",
          email: "bruce.guo@shmoxisw.com",
          phone: "+86 15821422068",
          website: "https://pritbiotech.com/",
          websiteNote: "（生产公司）"
        }
      }
    },
    {
      name: "BENZO-EO® Plus",
      nameZh: "BENZO-EO® Plus（饲料级）",
      specs: "Benzoic acid + phytogenic essential oils | 300 mg/kg | 25kg/bag",
      details: {
        summary:
          "Combination of benzoic acid with phytogenic essential oil compounds (feed grade). A breakthrough in poultry gut health management that stimulates digestive enzymes, improves feed efficiency and growth, and selectively reduces pathogenic bacteria without affecting beneficial Lactobacilli.",
        summaryZh:
          "苯甲酸与植物精油复合物（饲料级）。禽类肠道健康管理产品，可刺激消化酶分泌、提高饲料效率与生长性能，并选择性抑制致病菌而不影响有益乳酸杆菌。",
        composition: [
          "Form: Free-flowing light brown powder",
          "Extractable matter: Minimum 90%",
          "Benzoic acid: Minimum 80%",
          "Essential oil compounds (thymol, carvacrol, piperine): Approximately 10%",
          "Quality certification: GMO free"
        ],
        compositionZh: [
          "性状：自由流动的浅棕色粉末",
          "可提取物：不少于 90%",
          "苯甲酸：不少于 80%",
          "精油化合物（百里香酚、香芹酚、胡椒碱）：约 10%",
          "质量认证：非转基因（GMO Free）"
        ],
        features: [
          "Digestive enzyme stimulation: Essential oil compounds increase secretion of lipase, amylase, and trypsin. Piperine supports digestive enzyme activity, including amylase and lipase, helping improve the digestion of starches and fats.",
          "Bacterial cell wall permeability: Thymol and carvacrol increase membrane permeability so benzoic acid can enter bacterial cells more easily.",
          "Organic acid action: Benzoic acid lowers intracellular pH, disrupting cell function and depleting energy as bacteria try to restore homeostasis.",
          "Selective antimicrobial profile: Reduces E. coli, Salmonella, Campylobacter, and Clostridium perfringens while sparing beneficial Lactobacillus fermentum.",
          "Feed preservation: Benzoic acid helps support food and feed preservation and is particularly effective against yeasts.",
          "Stable during premixing and standard broiler feed processing."
        ],
        featuresZh: [
          "刺激消化酶：精油化合物促进脂肪酶、淀粉酶和胰蛋白酶分泌。胡椒碱有助于提高消化酶活性（包括淀粉酶和脂肪酶），改善淀粉与脂肪的消化。",
          "提高细菌细胞壁通透性：百里香酚与香芹酚增加细胞膜通透性，便于苯甲酸进入菌体。",
          "有机酸作用：苯甲酸降低胞内 pH，干扰细胞功能并消耗能量，迫使细菌重建稳态。",
          "选择性抑菌：降低大肠杆菌、沙门氏菌、弯曲杆菌和产气荚膜梭菌数量，同时不影响有益发酵乳杆菌。",
          "饲料防腐：苯甲酸有助于食品与饲料的保存，对酵母尤其有效。",
          "在预混及常规肉鸡饲料加工过程中保持稳定。"
        ],
        benefits: [
          "Increases daily weight gain in broilers",
          "Improves feed conversion ratio (FCR)",
          "Produces an average payback of 4:1 under optimum management conditions.",
          "Lowers digestive disease incidence and improves gut microflora",
          "Increases feed efficiency and growth rates in poultry"
        ],
        benefitsZh: [
          "提高肉鸡日增重",
          "改善饲料转化率（FCR）",
          "在优化管理条件下，平均回报为 4:1。",
          "降低消化道疾病发生率，改善肠道菌群",
          "提高家禽饲料效率与生长速度"
        ],
        dosage:
          "Recommended dosage in broiler feeds: Starter 300 mg/kg, Grower 300 mg/kg, Finisher 300 mg/kg.",
        dosageZh:
          "肉鸡饲料推荐添加量：开食料 300 mg/kg，生长料 300 mg/kg，育肥料 300 mg/kg。",
        shelfLife: "24 months from production date",
        shelfLifeZh: "自生产日期起 24 个月",
        countryOfOrigin: "Made in China",
        countryOfOriginZh: "中国制造",
        packaging: "25 kg multi-walled paper bags with polyethylene liner",
        packagingZh: "25 kg 多层纸袋（内衬聚乙烯）",
        precaution:
          "Store in a cool and dry place, free from insects. Use as directed in broiler feed formulations.",
        precautionZh:
          "置于阴凉干燥处保存，防止虫害。按肉鸡饲料配方推荐用量使用。",
        exporter: {
          title: "Manufactured By",
          name: "SHANDONG PRIT BIOTECHNOLOGY CO., LTD.",
          address:
            "Rm 302, NO. 1 XINGFU STREET, NO.49 XINHUA ROAD, LINZI DISTRICT, ZIBO, SHANDONG, CHINA"
        },
        exporterZh: {
          title: "生产商",
          name: "山东普瑞特生物科技有限公司",
          address: "中国山东省淄博市临淄区新华路49号幸福街1号302室"
        }
      }
    },
    {
      name: "GUTPRO MAX®",
      nameZh: "GUTPRO MAX®（饲料级）",
      specs: "SCFA + MCFA + essential oils | 250–300 g/MT | 25kg/bag",
      details: {
        summary:
          "Non-antibiotic growth promoter for poultry and livestock. A scientifically designed combination of short-chain fatty acids (SCFA), medium-chain fatty acids (MCFA), and selected essential oils developed to support gut health and digestive efficiency in modern poultry production. The synergistic formulation supports a healthy intestinal environment, favorable microbial balance, intestinal integrity, and efficient nutrient utilization.",
        summaryZh:
          "适用于家禽与畜禽的非抗生素生长促进剂。由短链脂肪酸（SCFA）、中链脂肪酸（MCFA）与精选精油科学复配而成，用于支持现代家禽生产中的肠道健康与消化效率。协同配方有助于维持健康的肠道环境、有利的微生物平衡、肠道完整性及高效养分利用。",
        composition: [
          "Short-chain fatty acids: Butyric acid, propionic acid & acetic acid",
          "Medium-chain fatty acids: Caproic acid, caprylic acid, capric acid & lauric acid",
          "Essential oils: Selected phytogenic essential oil compounds",
          "Form: Feed-grade formulation",
          "Application: Broiler, Layer & Breeder — for incorporation into complete feed"
        ],
        compositionZh: [
          "短链脂肪酸：丁酸、丙酸与乙酸",
          "中链脂肪酸：己酸、辛酸、癸酸与月桂酸",
          "精油：精选植物源精油化合物",
          "剂型：饲料级配方",
          "适用：肉鸡、蛋鸡与种鸡 — 用于添加到全价饲料中"
        ],
        features: [
          "Short-chain fatty acids: Support a favorable intestinal environment and contribute to normal intestinal physiology.",
          "Medium-chain fatty acids: Provide complementary fatty-acid activity and support intestinal and digestive function.",
          "Essential oils: Provide complementary phytogenic activity supporting gut microbial balance, digestive function, nutrient digestibility and antioxidant activity."
        ],
        featuresZh: [
          "短链脂肪酸：支持有利的肠道环境，并有助于维持正常肠道生理功能。",
          "中链脂肪酸：提供互补的脂肪酸作用，支持肠道与消化功能。",
          "精油：提供互补的植物源活性，支持肠道微生物平衡、消化功能、养分消化率与抗氧化活性。"
        ],
        benefits: [
          "Supports a healthy intestinal environment",
          "Helps maintain favorable gut microbial balance",
          "Supports intestinal integrity",
          "Supports digestive function and helps optimize nutrient utilization",
          "Supports feed efficiency",
          "Contributes to consistent production performance"
        ],
        benefitsZh: [
          "支持健康的肠道环境",
          "有助于维持有利的肠道微生物平衡",
          "支持肠道完整性",
          "支持消化功能并有助于优化养分利用",
          "支持饲料效率",
          "有助于稳定的生产性能"
        ],
        dosage:
          "Recommended dosage: 250–300 g/MT of complete feed. Suitable for broiler, layer and breeder rations.",
        dosageZh:
          "推荐添加量：每吨全价饲料 250–300 g。适用于肉鸡、蛋鸡与种鸡日粮。",
        shelfLife: "24 months from the date of manufacturing",
        shelfLifeZh: "自生产日期起 24 个月",
        countryOfOrigin: "China",
        countryOfOriginZh: "中国",
        packaging: "25 kg multi-walled paper bag with polyethylene liner",
        packagingZh: "25 kg 多层纸袋（内衬聚乙烯）",
        precautionLabel: "Storage and Handling",
        precautionLabelZh: "储存与操作",
        precaution:
          "Store in a cool, dry place away from direct sunlight and moisture. Manufactured using selected feed-grade raw materials under controlled production and quality-control procedures.",
        precautionZh:
          "置于阴凉干燥处保存，避免阳光直射和受潮。采用精选饲料级原料，在受控生产与质量控制程序下制造。",
        brochure: {
          file: "gutpro-max-brochure.jpg",
          downloadName: "PritBiotech Gutpro Max.jpg",
          buttonLabel: "Download Brochure",
          buttonLabelZh: "下载产品手册"
        },
        exporter: {
          title: "Manufactured By",
          name: "SHANDONG PRIT BIOTECHNOLOGY CO., LTD.",
          address:
            "Rm 302, NO. 1 XINGFU STREET, NO.49 XINHUA ROAD, LINZI DISTRICT, ZIBO, SHANDONG, CHINA"
        },
        exporterZh: {
          title: "生产商",
          name: "山东普瑞特生物科技有限公司",
          address: "中国山东省淄博市临淄区新华路49号幸福街1号302室"
        }
      }
    }
  ],
  phosphates: [
    {
      name: "Di Calcium Phosphate 18%",
      nameZh: "磷酸氢钙 18%",
      specs: "Granular & Powder | 25kg/bag",
      image: "dicalcium.png"
    }
  ]
};

export const categoryKeys = ["antibiotic", "coccidiostat", "api", "binder", "otherPremix", "phosphates"];

export const categoryIcons = {
  antibiotic: "Pill",
  coccidiostat: "ShieldCheck",
  api: "FlaskConical",
  binder: "Link",
  otherPremix: "Layers",
  phosphates: "Gem"
};
